import { CommonFragments } from './common.fragments';

export class RiskFragments {
  public static readonly riskFragment = `
    riskReturnCharacteristicsExhibit {
      benchmarkName
      effectiveDate
      portfolioName
      risks {
        timePeriodName
        values {
          benchmarkValue
          displayPercentage
          fundValue
          label
          rank
          id
        }
      }
      riskFactorGlossary {
        alphaPercentage
        betaNumber
        informationRatio
        rSquaredNumber
        sharpeRatio
        standardDeviationPercentage
        trackingErrorPercentage
      }
      ${CommonFragments.disclaimerFragment}
    }
  `;
}
